module.exports = __webpack_public_path__ + "static/media/green-saber.41ef504c.svg";